export const baseURL = process.env.REACT_APP_API_BASEURL;
export const clientId = process.env.REACT_APP_OCR_CLIENTID;
export const clientSecret = process.env.REACT_APP_OCR_SECRET;
export const clientIdValidate = process.env.REACT_APP_VALIDATE_CLIENTID;
export const clientSecretValidate = process.env.REACT_APP_VALIDATE_SECRET;
export const userName = process.env.REACT_APP_USERID;
export const userPass = process.env.REACT_APP_USERPWD;

export const SERVICE_VALIDATE = 'validation';


export const apiUrls = {
    login: {
        getToken: '/api/demo/v1/get-token'
    },
    ocr: {
        pan: '/api/demo/v1/verification/ocr/pan',
        aadhaar: '/api/demo/v1/verification/ocr/aadhaar',
    },
    validate: {
        ifsc: '/api/demo/v1/verification/ifsc',
        bank: {
            init: '/api/demo/v1/verification/bank/initiate',
            status: '/api/demo/v1/verification/bank/check'
        },
        pan: {
            init: '/api/demo/v1/verification/pan/initiate',
            status: '/api/demo/v1/verification/pan/check'
        },
        vpa: {
            init: '/api/demo/v1/verification/vpa/initiate',
            status: '/api/demo/v1/verification/vpa/check'
        },
        aadhaar: {
            init: '/api/demo/v1/verification/aadhaar/initiate',
            status: '/api/demo/v1/verification/aadhaar/otp'
        }
    }
}


export const statusCode = {
    success: '0x0200',
    failed: '0x0202',
    missing: '0x0203'
}


export const apiStatusCodes = {
    success: '0x0200',
    failed: '0x0202',
    missing: '0x0203'
}


export const apiStatusText = {
    unauthorized: 'UNAUTHORIZED',
    maintenance: 'maintenance'
}


export const appUrls = {
    user: {
        profile: '/user/profile',
        profileUpdate: '/user/profile/update',
        kycUpdate: '/user/profile/kyc',
        setting: '/user/settings'
    }
}